import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  message: '',
  showCross: false,
  title: '',
  type: null,
  autoHideDuration: null,
  vertical: 'top',
  horizontal: 'center',
  onClick: null,
};

const alertSlice = createSlice({
  name: 'alertState',
  initialState,
  reducers: {
    showAlert: (state, action) => {
      const {
        message,
        showCross = true,
        title = '',
        type = null,
        autoHideDuration = null,
        vertical = 'top',
        horizontal = 'center',
        onClick = null,
      } = action.payload || {};

      state.open = true;
      state.message = message || '';
      state.showCross = showCross;
      state.title = title;
      state.type = type;
      state.autoHideDuration = autoHideDuration;
      state.vertical = vertical;
      state.horizontal = horizontal;
      state.onClick = onClick;
    },
    hideAlert: (state) => {
      state.open = false;
      state.message = '';
      state.showCross = false;
      state.title = '';
      state.type = null;
      state.autoHideDuration = null;
      state.vertical = 'top';
      state.horizontal = 'center';
      state.onClick = null;
    },
  },
});

export const { showAlert, hideAlert } = alertSlice.actions;
export default alertSlice.reducer;
